module.exports = __webpack_public_path__ + "static/img/0-3home.0e42aef6.jpg";